/* Collection page with boost filter javascript - start */

var hide_filter_button = document.querySelector('#hide_filter');
//console.log('hide_filter_button found: ' + hide_filter_button);

if(hide_filter_button){
    hide_filter_button.addEventListener("click", hide_filter_Function);
    function hide_filter_Function() {
        var ProductGridContainer = document.querySelector('#ProductGridContainer');
        ProductGridContainer.classList.toggle('hide_filter_active');
        hide_filter_button.classList.toggle('active');

        if(hide_filter_button.classList.contains('active')){
            hide_filter_button.innerText = 'Show Filter';
            //console.log('Show');
        }
        else{
            hide_filter_button.innerText = 'Hide Filter';
            //console.log('Hide');
        }
        //console.log('hide_filter_button clicked');
    }
}


/* Collection page with boost filter javascript - end */

/* Collection page tabs javascript - start */







filtertabs = document.querySelectorAll('.filter-container a');

if(filtertabs){
    current_url = window.location.href;
    //console.log(window);
    //console.log('current_url: ' + current_url);
    let result = current_url.includes("Aactivity_tag");
    //console.log('result: ' + result);
    filtertabs.forEach(function (item, index){
        //.getAttribute('href')
        if(item == current_url){
            //console.log(' The index is ' + index +' The item is: ' + item);
            const datacol = String(item).split('Aactivity_tag=').slice(1).join("Aactivity_tag=") ; // prints: 20202-03
            var datacolfilter = datacol.replace(/<a.*>.*?<\/a>/ig,'').replace('%20','');
            //console.log('datacolfilter: ' + datacolfilter);

            filtertabsactive = document.querySelector('.filter-container a[data-collection="'+datacolfilter+'"]');
            filtertabsfirst = document.querySelector('.filter-container a');

            if(filtertabsactive != null){
                filtertabsfirst.classList.remove('active');
                filtertabsactive.classList.add('active');
            }
            else{
                filtertabsfirst.classList.add('active');
            }
        }
    });
}
/* Collection page tabs javascript - end */
3